import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import { APIROLEMAPPING_API, BaseGatewayImage, ROLE_API } from '@app/utils/apiUrl.js';
import { DeleteSingle, Get, Post } from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    objectDeviceStatus,
    deviceStatus,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue
} from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { BrowserView, MobileView } from 'react-device-detect';
import Select from 'react-select';
import SelectTree from '@app/components/select-tree/SelectTree';
import { NIL as NIL_UUID } from 'uuid';

const ApiRoleMapping = () => {
    const history = useHistory();
    const location = useLocation();
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role;
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(APIROLEMAPPING_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['apiRoleMappingData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '');

            return Get(APIROLEMAPPING_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.APIROLEMAPPING_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.data.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(
                                    URI_INTERNAL.APIROLEMAPPING_PATH,
                                    {
                                        page: page - 1,
                                        size: pageSize,
                                        search: search
                                    }
                                )
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    // chọn nhiều dòng + chọn roles
    const [selectedIds, setSelectedIds] = useState(new Set()); // id của các dòng đã tick
    const [selectedRoles, setSelectedRoles] = useState([]);    // các role chọn bởi AsyncPaginate

    const listRole = useQuery(['getAllRolesFromAuthServer'], () =>
        Get(ROLE_API.GET_PAGING, null, {
            PageIndex: 1,
            PageSize: 10000
        })
    );

    const lstRoleFlat =
        listRole?.data?.data?.length > 0
            ? listRole.data.data.map((x) => ({
                id: x.id,
                name: x.name,
                // normalize root parentId to NIL_UUID
                parentId:
                    x.parentId && x.parentId !== NIL_UUID ? x.parentId : NIL_UUID,
            }))
            : [];

    // === Chọn tất cả trên trang / chọn từng dòng ===
    const currentPageIds = data?.data?.map((x) => x.id) ?? [];
    const isAllPageChecked =
        currentPageIds.length > 0 && currentPageIds.every((id) => selectedIds.has(id));

    const toggleCheckAllPage = () => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (isAllPageChecked) {
                // Bỏ chọn tất cả
                currentPageIds.forEach((id) => next.delete(id));
            } else {
                // Chọn tất cả
                currentPageIds.forEach((id) => next.add(id));
            }
            return next;
        });
    };

    const toggleRow = (id) => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    // === Bulk assign roles ===
    const bulkAssignMutation = useMutation((payload) =>
        Post(APIROLEMAPPING_API.BULK_ASSIGN_ROLES, null, payload)
    );

    const onApplyRolesForSelected = () => {
        if (selectedIds.size === 0) {
            toast.warn('Vui lòng chọn ít nhất một dòng.');
            return;
        }
        if (!selectedRoles || selectedRoles.length === 0) {
            toast.warn('Vui lòng chọn ít nhất một quyền.');
            return;
        }

        // Chuẩn hoá về dạng AllowedRole[] theo đúng DTO của BE
        const allowedRolesForSend = selectedRoles.map(r => ({
            id: r.id,         // Guid
            name: r.name ?? r.label ?? r.value // tuỳ nguồn dữ liệu, ưu tiên name
        }));

        // Lấy các ApiRoleMapping đã tick và gắn LstAllowedRoles cho từng item
        const itemsForSend = (data?.data ?? [])
            .filter(x => selectedIds.has(x.id))
            .map(x => ({
                id: x.id,                  // Guid? nếu BE không cần Id khi bulk-add mới, có thể bỏ
                controller: x.controller,  // theo ApiRoleMappingRequest
                action: x.action,          // theo ApiRoleMappingRequest
                lstAllowedRoles: allowedRolesForSend
            }));

        // Gọi API: endpoint nhận List<ApiRoleMappingRequest>
        bulkAssignMutation.mutate(itemsForSend, {
            onSuccess: () => {
                toast.success('Áp dụng quyền thành công.');
                setSelectedIds(new Set());
                // (tuỳ chọn) Optimistic update UI cột "Các quyền cho phép dùng"
                // setData(prev => ({
                //   ...prev,
                //   data: prev.data.map(row =>
                //     selectedIds.has(row.id)
                //       ? { ...row, lstAllowedRoles: allowedRolesForSend }
                //       : row
                //   )
                // }));
                refetch();
            },
            onError: () => {
                toast.error('Áp dụng quyền thất bại, vui lòng thử lại.');
            },
        });
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header bg-white py-3">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-shield-alt mr-2" />
                                Danh sách phân quyền API
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
                                <form className="form-inline d-flex flex-column flex-md-row align-items-start align-items-md-center mb-2 mb-md-0 header-form-mobile flex-grow-1" style={{ gap: '0.5rem' }}>
                                    <div className="d-flex flex-row align-items-center mb-2 mb-md-0 mr-md-3">
                                        <label
                                            htmlFor="exampleEmail2"
                                            className="mr-2 mb-0"
                                        >
                                            Hiển thị :
                                        </label>
                                        <select
                                            className="form-control w-auto"
                                            value={pageSize}
                                            onChange={(e) => onChangeShowNumber(e)}
                                        >
                                            {objectShowNumber.map((item, key) => (
                                                <option
                                                    key={Number(key)}
                                                    value={item.value}
                                                >
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-2 mb-md-0 mr-md-2 select-tree-mobile">
                                        <SelectTree
                                            data={lstRoleFlat}
                                            showSearchBox
                                            Placeholder="Chọn quyền truy cập"
                                            positionExpand="right"
                                            multiSelect
                                            onChange={(valueArray) => {
                                                setSelectedRoles(valueArray || []);
                                            }}
                                        />
                                    </div>
                                </form>
                                <div className="d-flex flex-row action-btn-group-mobile mt-2 mt-md-0" style={{ gap: '0.5rem' }}>
                                    <button
                                        type="button"
                                        className="btn btn-success flex-fill"
                                        disabled={
                                            selectedIds.size === 0 ||
                                            (selectedRoles?.length ?? 0) === 0 ||
                                            bulkAssignMutation.isLoading
                                        }
                                        onClick={onApplyRolesForSelected}
                                        title="Áp dụng quyền cho các dòng đã chọn"
                                    >
                                        Áp dụng
                                    </button>
                                    <NavLink
                                        className="nav-link-reject nav-link p-0 flex-fill"
                                        to={URI_INTERNAL.APIROLEMAPPING_CREATE_PATH}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-info w-100"
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            Thêm mới
                                        </button>
                                    </NavLink>
                                </div>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                // style={{
                                //     marginTop: accountRoleAdmin
                                //         ? '0px'
                                //         : '20px'
                                // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <Table striped bordered hover className="mobile-card-view">
                                                <thead>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Tên controller
                                                        </th>
                                                        <th className="sorting">
                                                            Tên Action
                                                        </th>
                                                        <th className="sorting">
                                                            Các quyền cho phép
                                                            dùng
                                                        </th>
                                                        <th className="sorting" style={{ width: 36, textAlign: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={isAllPageChecked}
                                                                onChange={toggleCheckAllPage}
                                                                title="Chọn/bỏ chọn tất cả trên trang"
                                                            />
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data != null &&
                                                    data.data != null &&
                                                    data.data != null &&
                                                    data.data !== undefined &&
                                                    data.data.length > 0 ? (
                                                    <tbody>
                                                        {data.data.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1 stt-mobile" data-label="STT">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td data-label="Tên controller">
                                                                        {
                                                                            item.controller
                                                                        }
                                                                    </td>
                                                                    <td data-label="Tên action">
                                                                        {
                                                                            item.action
                                                                        }
                                                                    </td>
                                                                    <td data-label="Các quyền cho phép">
                                                                        {item.lstAllowedRoles
                                                                            ?.map(
                                                                                (
                                                                                    x
                                                                                ) =>
                                                                                    x.name
                                                                            )
                                                                            .join(
                                                                                ', '
                                                                            )}
                                                                    </td>
                                                                    <td data-label="Chọn" style={{ textAlign: 'center' }}>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedIds.has(item.id)}
                                                                            onChange={() => toggleRow(item.id)}
                                                                            title={`Chọn ${item.controller}.${item.action}`}
                                                                        />
                                                                    </td>
                                                                    <td data-label="Chức năng">
                                                                        <div className="d-flex justify-content-center action-buttons-mobile-container">
                                                                            <NavLink
                                                                                to={createUrlWithParam(
                                                                                    URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
                                                                                    { id: item.id }
                                                                                )}
                                                                                exact
                                                                                className="btn btn-outline-primary btn-sm mr-2 btn-action-mobile"
                                                                            >
                                                                                <i title="Sửa" className="fas fa-pen" /> <span className="d-inline d-md-none ml-1">Sửa</span>
                                                                            </NavLink>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-outline-danger btn-sm btn-action-mobile"
                                                                                onClick={() =>
                                                                                    deleteAction(
                                                                                        item.id,
                                                                                        item.noiDungDeNghi
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i title="Xóa" className="fas fa-trash" /> <span className="d-inline d-md-none ml-1">Xóa</span>
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                                <tfoot>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Tên controller
                                                        </th>
                                                        <th className="sorting">
                                                            Tên Action
                                                        </th>
                                                        <th className="sorting">
                                                            Các quyền cho phép
                                                            dùng
                                                        </th>
                                                        <th></th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data != null
                                                            ? data.totalRecords
                                                            : 0
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default ApiRoleMapping;
